export const NODE_TYPE_MATHML_EXPRESSION = 'mathml-expression';